//lang.js
import Vue from "vue"
import VueI18n from "vue-i18n"

import tw from "./tw.json"
import en from "./en.json"
import vuetify_tw from "./vuetify_tw.json"
import vuetify_en from "./vuetify_en.json"

import currency from "./currency.json"
import country from "./country.json"
import timezone from "./timezone.json"

Vue.use(VueI18n)
// //eslint-disable-next-line
// let locale = window.location.pathname.replace(/^\/([^\/]+).*/i, "$1")
// if (locale != "en" && locale != "tw") {
//     locale = localStorage.getItem("language") || "tw"
// } else {
//     localStorage.setItem("language", locale)
// }
const locale = localStorage.getItem("language") || "tw"

const messages = {
  tw: {
    ...tw,
    ...vuetify_tw,
    Country: country["TW"],
    Currency: currency["TW"],
    Timezone: timezone["TW"]
  },
  en: {
    ...en,
    ...vuetify_en,
    Country: country["US"],
    Currency: currency["US"],
    Timezone: timezone["US"]
  }
}

const i18n = new VueI18n({
  /** 默认值 */
  locale,
  messages,
  fallbackLocale: "tw",
  silentTranslationWarn: true
})

export default i18n
